import React from 'react';
import { Navigate } from 'react-router-dom';
import { isLoggedIn } from '../../app/auth';

/**
 * Wraps protected content; redirects to /login if not logged in.
 */
export default function ProtectedRoute({ children }) {
  if (!isLoggedIn()) return <Navigate to="/login" replace />;
  return children;
}
